import { useHistory } from 'react-router-dom'
import { useAuth } from 'lib/auth'
import { gtmEvent } from 'lib/gtm'
import { useCoachBookStudentNavigation } from 'lib/pga-coach/use-coach-fast-book-student'

// With fast book on, adding a booking opens the "Book a student" overlay. With
// it off it follows the schedule page's Book Student link to the booking page.
// Returns null when neither is available so callers can hide the action.
const useAddBookingAction = ({ formLabel }) => {
  const history = useHistory()
  const { user } = useAuth()
  const {
    isCoachFastBookEnabled,
    navigateToBookStudent,
  } = useCoachBookStudentNavigation()
  const bookingUrl = user?.coach?.bookingUrl

  if (!isCoachFastBookEnabled && !bookingUrl) return null

  return {
    href: isCoachFastBookEnabled ? undefined : bookingUrl,
    onClick: () => {
      gtmEvent({
        event: 'formSubmit',
        formCategory: 'book-session',
        formAction: 'clicked-book-session-button',
        formLabel,
      })
      if (isCoachFastBookEnabled) {
        navigateToBookStudent(history)
      }
    },
  }
}

export default useAddBookingAction
